import { render } from "./SterfietsInfo.vue?vue&type=template&id=0ede2306&scoped=true"
import script from "./SterfietsInfo.vue?vue&type=script&lang=js"
export * from "./SterfietsInfo.vue?vue&type=script&lang=js"

import "./SterfietsInfo.vue?vue&type=style&index=0&id=0ede2306&lang=scss&scoped=true"

import exportComponent from "/buddy/denhaagfietst-sterfietsroutes/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ede2306"]])

export default __exports__